<template>
  <div>
    <h1 class="display-heading">Change Company Type</h1>

    <div class="mb-5">
      <p>
        Current Corporate Account Type:
        <b>{{
          getCompanyTypeByValue(companyType)
            ? getCompanyTypeByValue(companyType).text
            : ""
        }}</b>
      </p>
    </div>

    <div class="mb-3">
      <h5 class="mb-3">Change Company Type</h5>
      <div class="d-flex">
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: newCompanyType === 2,
          }"
          @click="newCompanyType = 2"
        >
          <div>
            <div>
              <i class="fa fa-user-friends"></i>
            </div>
            <p>{{ getCompanyTypeByValue(2).text }}</p>
          </div>
        </a>
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: newCompanyType === 1,
          }"
          @click="newCompanyType = 1"
        >
          <div class="">
            <div>
              <i class="fa fa-briefcase"></i>
            </div>
            <p>{{ getCompanyTypeByValue(1).text }}</p>
          </div>
        </a>
      </div>
    </div>

    <div v-if="companyType!==newCompanyType">
        <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="showConfirmationUpdateCompanyType">Confirm Changes</button>
        <button class="btn btn-secondary" type="button" @click="getCompanyProfile">Discard Changes</button>
    </div>

    <div class="mt-5">
        <div class="mb-5">
          <h5>Employee-Self-Paying Healthcare</h5>
          <ul>
            <li>
              <b>FREE</b> services for corporate customers' employees managing
              self-expenses
            </li>
            <li>
              <b>FREE</b> services for adding own family members as dependents,
              even their benefits are not sponsored by employer
            </li>
          </ul>
        </div>
        <div class="mb-5">
          <h5>Employer-Sponsored Healthcare</h5>
          <ul>
            <li>
              Minimal administration fee for managing corporate-sponsored
              employee outpatient benefits
            </li>
            <li>
              Employees and dependents' medical history during employment can be
              transferrable to personal medical account seamlessly after
              employment ends, or vice versa, if future employer is also our
              registered corporate user.
            </li>
            <li>
              <b>FREE</b> services for adding own family members as dependents,
              even their benefits are not sponsored by employer
            </li>
          </ul>
        </div>
        <div>
          <h5>Both of these accounts can enjoy:</h5>
          <ul>
            <li>
              Medical certificates send to both employee and employer digitally
            </li>
            <li>
              Consultation fee, medicine and laboratory costs and quality are
              controlled within our ecosystem, guided by our strategic partner,
              FPMPAM.
            </li>
            <li>
              <b>FREE</b> life-time medical record storage
              <ul>
                <li>
                  - i.e. uploaded medical reports, consultation and medication
                  history, fully encrypted and only accessible by healthcare
                  providers with prior consents given by customers.
                </li>
              </ul>
            </li>
            <li>
              Reduce risk of misdiagnosis, avoid similar laboratory test due to
              unconnected healthcare providers.
            </li>
          </ul>
        </div>
      </div>

    <popup-modal ref="popupUpdateCompanyType" :hasCloseButton="false" title="Confirm Update Company Type">
        <template slot="content">
            <div v-html="saveMessage"></div>
        </template>
        <template slot="footer">
            <template v-if="!updateSuccess">
                <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="updateCompanyType">Proceed</button>
                <button type="button" class="btn btn-secondary" @click="discardUpdate">Discard</button>
            </template>
            <template v-else>
                <button v-if="newCompanyType===1" type="button" class="btn btn-primary btn-primary-insv mr-2" @click="dismissAndGoToManageTiers">Manage Employee Tiers</button>
                <button v-if="newCompanyType===2" type="button" class="btn btn-primary btn-primary-insv mr-2" @click="dismissAndViewCompanyEmployees">View Employees</button>
                <!-- <button type="button" class="btn btn-secondary" @click="discardUpdate">Dismiss</button> -->
            </template>
        </template>
    </popup-modal>
  </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import { getCompanyTypeByValue } from '@/config/companyTypes';
export default {
    'name': 'ChangeCompanyType',
    'components': {
        popupModal
    },
    data () {
        return {
            'companyType': 0,
            'newCompanyType': 0,
            'saveMessage': '',
            'updateSuccess': false
        };
    },
    mounted () {
        this.getCompanyProfile();
    },
    'methods': {
        getCompanyTypeByValue,
        getCompanyProfile () {
            this.axios.get('Company/Profile').then(({ data }) => {
                let companyData = data.data;

                if (companyData != null) {
                    this.companyType = companyData.t;
                    this.newCompanyType = companyData.t;
                }
            });
        },
        updateCompanyType () {
            this.saveMessage = `<p>Saving company type...</p>`;

            this.axios.post('Company/UpdateCompanyType', {
                'companyType': this.newCompanyType
            }).then(() => {
                this.updateSuccess = true;
                this.saveMessage = 'Company type updated successfully!';
                this.axios.get('account/GetLoginStatus').then(({ data }) => {
                    if (data.data) {
                        this.$store.commit('setUserDetails', data.data);
                        this.$store.commit('setAppStatus', false);
                    }
                });
            }).catch(() => {
                this.saveMessage = 'Error updating company type. Please try again.';
            });
        },
        showConfirmationUpdateCompanyType () {
            this.saveMessage = `<p>Are you sure you want to change company type?</p>
            <p>Current Company Type: <b>${getCompanyTypeByValue(this.companyType) ? getCompanyTypeByValue(this.companyType).text : ''}</b></p>
            <p>Updated Company Type: <b>${getCompanyTypeByValue(this.newCompanyType) ? getCompanyTypeByValue(this.newCompanyType).text : ''}</b></p>`;
            this.$refs.popupUpdateCompanyType.show();
        },
        discardUpdate () {
            this.getCompanyProfile();
            this.$refs.popupUpdateCompanyType.hide();
        },
        dismissAndGoToManageTiers () {
            this.$refs.popupUpdateCompanyType.hide().then(() => {
                this.$router.push({
                    'name': 'tier-list',
                    'query': {
                        'isChangeCompanyType': true
                    }
                });
            });
        },
        dismissAndViewCompanyEmployees () {
            this.$refs.popupUpdateCompanyType.hide().then(() => {
                this.$router.push({
                    'name': 'employee-self-paying-list'
                });
            });
        }
    }
};
</script>

<style>
.btn-choose-account-type {
  display: block;
  height: 150px;
  width: 200px;
  color: initial;
}

.btn-outline-insv {
  border-color: #009344;
  color: #009344;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-outline-insv:hover,
.btn-outline-insv.selected {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-choose-account-type + .btn-choose-account-type {
  margin-left: 20px;
}

.btn-choose-account-type i.fa {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.btn-choose-account-type p {
  font-size: 18px;
  margin-bottom: 0;
}
</style>
